// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTESTS_I_WANT_TO_RECEIVE_notifications = "Chci dost\u00e1vat %(notifications)s na nov\u00e9 sout\u011b\u017ee";
export const CONTESTS_WITH_AMBASSADORS = "Sout\u011b\u017e\u00edme s ambasadorkami";
export const CONTESTS_WITH_MK = "Sout\u011b\u017e\u00edme s kon\u00edkem";
export const NOTIFICATIONS = "Upozorn\u011bn\u00ed";
export const TOPIC_CONTESTS_ENDED_TITLE = "Ukon\u010den\u00e9 sout\u011b\u017ee";
export const TOPIC_CONTESTS_NO_RUNNING = "Moment\u00e1ln\u011b neprob\u00edh\u00e1 \u017e\u00e1dn\u00e1 sout\u011b\u017e. Zkus p\u0159ij\u00edt pozd\u011bji, sout\u011b\u017e\u00ed se \u010dasto.";
